import axios from "axios";
import { SessionStore } from "../../types/store";
import { newAbortSignal } from "../../utils";
import { ExportDataRequest } from "../../types/model/export";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/exports/run`;

export const runExport = async (
  definitionId: number,
  payload: ExportDataRequest,
): Promise<any> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.post(
    `${BASE_URL}/${definitionId}`,
    payload,
    {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      responseType: "blob",
      timeout: Number.parseInt(process.env.REACT_APP_AXIOS_TIME_OUT!),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    }
  );

  const disposition = res.headers["content-disposition"];
  const filename =
    disposition?.match(/filename="?(.+?)"?$/)?.[1] ?? "export.xlsx";

  const url = URL.createObjectURL(res.data);

  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  link.remove();

  URL.revokeObjectURL(url);

  return res.data;
};
